export const API_JWT_ACCESS_URL = "https://sso.trueshape.sg/sso/api/token/"; //JWT access token API
export const API_JWT_REFRESH_URL =
  "https://sso.trueshape.sg/sso/api/token/refresh/"; //JWT refresh token API
export const API_JWT_BOOTSTRAP_URL =
  "https://sso.trueshape.sg/sso/api/token/bootstrap/"; //JWT bootstrap token API
export const API_LOGOUT_URL = "https://sso.trueshape.sg/sso/api/logout/";
export const API_EVENT_URL = "https://edate.trueshape.sg/edate/event/"; //Packages API
export const API_USER_URL = "https://edate.trueshape.sg/user/"; //Users API
export const TIMEOUT_SEC = 10; //API timeout setting
export const MODAL_TIMEOUT_SEC = 0.3; //API timeout setting
